<div class="shop-sellers-batch-detail-container">
  <h1 class="text-2xl font-bold mb-4">Detalhes do lote</h1>

  @if (error) {
    <app-alert [type]="'danger'">{{ error }}</app-alert>
  }

  @if (paginationState().loading) {
    <div class="mb-4">
      <app-loading size="large" color="primary"/>
    </div>
  }

  @if (!paginationState().loading && batch) {
    <div class="mb-6 space-y-1">
      <div><span class="font-semibold">ID:</span> {{ batch.id }}</div>
      <div><span class="font-semibold">Arquivo:</span> {{ batch.fileName }}</div>
      <div><span class="font-semibold">SHA256:</span> {{ batch.sha256 }}</div>
      <div><span class="font-semibold">Total de linhas:</span> {{ batch.rowCount }}</div>
      <div><span class="font-semibold">Usuário:</span> {{ batch.userEmail || 'Sistema' }}</div>
      <div><span class="font-semibold">Criado em:</span> {{ batch.createdAt }}</div>
      <div><span class="font-semibold">Processado em:</span> {{ batch.processedAt }}</div>
    </div>

    <div class="overflow-x-auto">
      <table class="table-auto w-full border-collapse border border-slate-400">
        <thead>
          <tr class="bg-neutral-100 dark:bg-neutral-700">
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Documento</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Operação</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Processado</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Código</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Criado em</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Processado em</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Ações</th>
          </tr>
        </thead>
        <tbody>
          @for (item of batch.items.content; track item; let even = $even) {
            <tr [ngClass]="even ? 'bg-neutral-50 dark:bg-neutral-800' : 'bg-white dark:bg-neutral-900'">
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ item.documentId || 'Não há.' }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ operationType(item.operation) }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ item.processed ? 'Sim' : 'Não' }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ operationStatus(item.submissionResultCode, item.operation) }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ item.createdAt }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ item.processedAt || '-' }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2 space-x-2">
                <app-button (click)="openJson(item)">Ver Payload</app-button>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="7" class="p-4">Nenhum registro encontrado.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <app-pagination [paginationState]="paginationState()" [onPaginationChange]="onPageChange"></app-pagination>
  }

  <app-modal #jsonModal [open]="false" [closeOnClickOutside]="true" title="JSON do registro">
    <div class="max-h-[70vh] overflow-auto">
      <pre class="text-xs whitespace-pre-wrap">{{ modalJsonContent }}</pre>
      <div class="my-4">
        @if (selectedItem?.submissionResult) {
          <p class="mb-2">Resultado da operação:</p>
          <pre class="text-xs whitespace-pre-wrap mb-2">{{ selectedItem?.submissionResult }}</pre>
        }
      </div>
    </div>
  </app-modal>
</div>
